<style scoped lang="sass">
.readOnlyDialog
  display: flex
  flex-direction: column
  align-items: center
  width: 283px
  padding: 25px
  border-radius: 15px

  .icon
    margin-top: 2px
    width: 95px
    height: 95px

  .title
    margin-top: 22px
    padding: 0 4px
    font-size: 18px
    line-height: 20px
    font-weight: bold
    text-align: center
    color: #000

  .content
    margin-top: 9px
    padding: 0 4px
    font-size: 14px
    line-height: 17px
    text-align: center
    font-weight: 500
    color: #000
    opacity: 0.75

  .button
    margin-top: 23px
    height: 54px
    font-size: 14px
    font-weight: bold
    border: none
    border-radius: 4px !important
</style>

<template lang="pug">
van-popup.readOnlyDialog(v-model="show")
  img.icon(src="@/assets/icon/read-only-icon.png")
  .title(v-html="title")
  .content(v-html="content")
  van-button.button(type="primary" block @click="closeDialog") {{ t('ok', 'OK') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t } from '@/utils/language'

@Component({
  props: {
    dineInSettings: Object
  },

  computed: {
    /**
     * @returns {String} 弹窗标题
     */
    title() {
      return this.dineInSettings?.viewOnlyMessage?.title ?? ''
    },

    /**
     * @returns {String} 弹窗内容
     */
    content() {
      return this.dineInSettings?.viewOnlyMessage?.content ?? ''
    },
  }
})

class TermsPrivacy extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  show = false // 控制显示弹窗

  mounted() {
    // 若不是只读模式，则不显示弹窗
    if (!this.$route.path.includes('/r/v/')) return
    // 若本地缓存不存在 hideReadOnlyDialog，就显示弹窗
    const isShowReadOnlyDialog = !localStorage.getItem('hideReadOnlyDialog')
    if (isShowReadOnlyDialog) this.show = true
  }

  // 关闭弹窗
  closeDialog() {
    this.show = false
    localStorage.setItem('hideReadOnlyDialog', true)
  }
}

export default TermsPrivacy
</script>